// @flow
import React from "react";
import I18n from "../../i18n/I18n";
import styles from "./UsersCard.scss";

type Props = {
    data: Array
}

const UsersCards = (props: Props) => {
const data = props.data || "";
  return (
     <div className={styles.wrapper}>
         <div className={styles.ctr}>
             <div className={styles.box}>
                {data.first_name
                    ? <div className={styles.eachSpec}>
                        <p className={styles.header}>
                            {I18n.getText("settings.user-first", {}, "firstName")}
                        </p>
                        <p className={styles.bold}>
                            { data.first_name }
                        </p>
                    </div>
                    : ''
                }
                {data.last_name
                    ? <div className={styles.eachSpec}>
                        <p className={styles.header}>
                            {I18n.getText("settings.user-last", {}, "lastName")}
                        </p>
                        <p className={styles.bold}>
                            { data.last_name }
                        </p>
                    </div>
                    : ''
                }
                {data.email
                    ? <div className={styles.eachSpec}>
                        <p className={styles.header}>
                            {I18n.getText("settings.user-email", {}, "email")}
                        </p>
                        <p className={styles.bold}>
                            { data.email }
                        </p>
                    </div>
                    : ''
                }
             </div>
         </div>
     </div>
  );
};

export default UsersCards;



// WEBPACK FOOTER //
// ./src/components/settings/UsersCard.js